const TIMING_DUE_SOON_STATUSES = new Set(['expiring_soon', 'due_soon']);
const TIMING_EXPIRED_STATUSES = new Set(['expired', 'overdue']);

const getTrainingTimingStatus = (item) => (
  item?.status_band ||
  item?.renewal_status ||
  item?.timing_status ||
  item?.renewalStatus ||
  item?.status
);

const getTrainingExpiryDate = (item) => item?.expires_at || item?.expiry_date;

const isExpiryDatePast = (expiryDate) => {
  if (!expiryDate) return false;
  const parsed = new Date(expiryDate);
  if (Number.isNaN(parsed.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  parsed.setHours(0, 0, 0, 0);
  return parsed < today;
};

const isTrainingExpiredOrOverdue = (item) => (
  TIMING_EXPIRED_STATUSES.has(getTrainingTimingStatus(item)) ||
  isExpiryDatePast(getTrainingExpiryDate(item))
);

const isTrainingDueSoon = (item) => (
  !isTrainingExpiredOrOverdue(item) &&
  TIMING_DUE_SOON_STATUSES.has(getTrainingTimingStatus(item))
);

export const getTrainingRenewalRequestDefaults = (items = []) => {
  const renewalItems = (Array.isArray(items) ? items : []).filter((item) =>
    !item?.renewal_pending &&
    (isTrainingExpiredOrOverdue(item) || isTrainingDueSoon(item))
  );

  return {
    trainingTypes: [...new Set(renewalItems.map((item) => item?.code).filter(Boolean))],
    includeRenewals: renewalItems.length > 0,
  };
};
